import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { PromotionExposeGroup } from '../interface';
import { PutDiscountCodeReferenceDto } from './PutDiscountCodeReferenceDto';
export class PutPromotionProviderDto {
    constructor() {
        this.pos_guid = '';
    }
}
__decorate([
    ApiProperty({ type: () => String, description: 'toast specific pos_giud, it is used to bind our promotion to toast promotion' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], PutPromotionProviderDto.prototype, "pos_guid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PutDiscountCodeReferenceDto }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsOptional({ always: true }),
    Type(() => PutDiscountCodeReferenceDto),
    __metadata("design:type", PutDiscountCodeReferenceDto)
], PutPromotionProviderDto.prototype, "discountCodeReference", void 0);
//# sourceMappingURL=PutPromotionProviderDto.js.map